import { OekakiToolSetting } from "@/features/settings/components/OekakiToolSetting";

/** 添付欄から変更できるお絵描きツール設定と外部ツールの案内。 */
export const OekakiSettingsDetails: React.FunctionComponent = () => {
  return (
    <details>
      <summary className="cursor-pointer pl-1.5 text-sm font-medium text-foreground">
        お絵描き設定
      </summary>
      <section
        className="mt-2 flex flex-col gap-1 pl-1.5"
        aria-label="お絵描き設定項目"
      >
        <OekakiToolSetting className="justify-start px-0 py-0" />
        <p className="text-xs text-muted-foreground">
          ※はっちゃんはお絵かきボタンを押さずにそのまま開いてください
        </p>
      </section>
    </details>
  );
};
